export default __webpack_public_path__ + "static/media/org.bd190fd2.png";